const SCOPE = 'app/PrinterProfile';

export const GET_LIST = `${SCOPE}/GET_LIST`;
export const GET_ENTITY = `${SCOPE}/GET_ENTITY`;
export const SAVE_ENTITY = `${SCOPE}/SAVE_ENTITY`;
export const DELETE_ENTITY = `${SCOPE}/DELETE_ENTITY`;
export const UPDATE_ENTITY = `${SCOPE}/UPDATE_ENTITY`;
export const ACTION_RESOLVED = `${SCOPE}/ACTION_RESOLVED`;
